import React from 'react';
import styled from 'styled-components';
import AppIcon from 'src/images/appIcon.png';

const StyledAvatar = styled.span`
  position:relative;
  height:30px !important;
  width:30px !important;
  line-height: inherit;
  border-radius:50%;
  display: inline-block;
  background-size:cover;
  background-position: center center;
  vertical-align:middle;
  margin-right:5px;
  background-image: ${({ icon }) => `url(${icon})`};

`;

function SimplyDoChip({ style, colour }) {
  return (
    <div style={style || { display: 'inline-block' }}>
      <StyledAvatar icon={AppIcon} />
      <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
        <span style={{ marginBottom: 0, color: colour || 'inherit' }}> Simply Do</span>
      </div>
    </div>
  );
}

export default SimplyDoChip;
